import TransitionPage from "../shared/components/animations/TransitionPage";
import Footer from "../shared/layout/Footer";
import PageInDevelopment from "./PageInDevelopment";

const Realisations = () => {
  return (
    <>
    <TransitionPage />
    <PageInDevelopment />
    <Footer />
  </>
  );
};

export default Realisations;
